var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 40,
    viewBox: "0 0 67 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 38H25.95L11.65 16.35V38H3.1V2.9H11.65L25.95 24.65V2.9H34.5V38Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5977 9.92C53.5577 9.92 56.1443 10.5067 58.3577 11.68C60.571 12.8533 62.2777 14.5067 63.4777 16.64C64.7043 18.7467 65.3177 21.1867 65.3177 23.96C65.3177 26.7067 64.7043 29.1467 63.4777 31.28C62.2777 33.4133 60.5577 35.0667 58.3177 36.24C56.1043 37.4133 53.531 38 50.5977 38H40.0777V9.92H50.5977ZM50.1577 32.08C52.7443 32.08 54.7577 31.3733 56.1977 29.96C57.6377 28.5467 58.3577 26.5467 58.3577 23.96C58.3577 21.3733 57.6377 19.36 56.1977 17.92C54.7577 16.48 52.7443 15.76 50.1577 15.76H46.9177V32.08H50.1577Z",
    fill: "#F60512"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3bc5878c932788d2e52f8cac7a88808b.svg";
export { ForwardRef as ReactComponent };